import { render, staticRenderFns } from "./topology.vue?vue&type=template&id=1570a7f9&"
import script from "./topology.vue?vue&type=script&lang=ts&"
export * from "./topology.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "topology.vue"
export default component.exports